import PropTypes from "prop-types";

export const _PostCardGrid = {
  entryType: PropTypes.string,
  posts: PropTypes.array,
};

export const PostCardGridPropTypes = _PostCardGrid;
